<template>
  <div :id="$id('eingabe-werte')">
    <b-container fluid>
      <b-row class="top-buffer" v-for="(eingabeWert, index) in attribut.eingabeWerte" v-bind:key="eingabeWert.id" >
        <b-col sm="1" class="padding-0">
          <div class="float-left">
            <b-form-radio :ref="'radio-eingabe-wert'+index"
                          :disabled="eingabeWert.disabled"
                          :id="$id('radio-eingabe-wert'+index)" :name="groupName"
                          v-model="selectedEingabeWert" :value="eingabeWert"
                          v-on:change="onRadioButtonChange(index, eingabeWert)" />
          </div>
        </b-col>
        <b-col sm="4" class="padding-0">
          <div class="float-left">
            <b-form-input type="number" size="sm"
                          :disabled="eingabeWert.disabled"
                          style="width: 100px;font-weight: 500"
                          :ref="'text-eingabe-wert'+index"
                          :id="$id('text-eingabe-wert'+index)"
                          :min="eingabeWert.bereich.lowerBound"
                          :max="eingabeWert.bereich.upperBound"
                          :step="eingabeWert.schrittweite"
                          :value="eingabeWert.value"
                          :state="formInputState(eingabeWert)"
                          v-model="eingabeWert.value"
                          v-on:blur="submitValue(eingabeWert)"
                          v-on:keydown.enter="submitValue(eingabeWert)"/>
            <b-tooltip :target="$id('text-eingabe-wert'+index)"
                       :title="getTooltipText(eingabeWert)"
                       placement="right"
                       triggers="hover"/>

          </div>
        </b-col>
        <b-col sm="6">
          <!--                    <span class="float-left" :style="{((selectedEingabeWert!= null && selectedEingabeWert.name===eingabeWert.name)? 'font-weight:500' : ''), color: (eingabeWert.disabled ? 'gray' : 'black')}">-->
          <span class="float-left" v-bind:style="{fontWeight: ((selectedEingabeWert!= null && selectedEingabeWert.name===eingabeWert.name) ? 500 : 0),
                            color: (eingabeWert.disabled ? '#6c757d' : 'black')}">
                        {{ eingabeWert.i18NName }}
                        <Vorzugswert :vorzugswert="eingabeWert.vorzugswert"/>
                        <i v-if="eingabeWert.isEingeschraenkt && !eingabeWert.disabled" :title="getLimitedText(eingabeWert)">
                            <b-icon  icon="exclamation-circle-fill" variant="primary" placement="right"></b-icon>
                        </i>
                        <I18NImage :i18-n-pic-id="eingabeWert.i18NPictureId" :pic-title="eingabeWert.i18NName" :i18-n-description="eingabeWert.i18NDescription"/>
                    </span>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import I18NImage from "@/components/config-page/utils/I18NImage";
import Vorzugswert from "@/components/config-page/utils/Vorzugswert";
import i18n from "../../../i18n/i18n";

export default {
  name: 'EingabeWerte',
  props: ['attribut', 'groupName', 'gruppenName'],
  components: {I18NImage, Vorzugswert},
  computed: {
    selectedEingabeWert: {
      get() {
        return this.attribut.selectedEingabeWert;
      },
      set() {
        //this.commitSelectedEingabeWert(value);
      }
    }
  },
  methods: {
    onRadioButtonChange(index, wert) {
      let ref = 'text-eingabe-wert' + index;
      this.$refs[ref][0].focus();
      this.triggerVorzugswertReminder(wert)
    },
    submitValue(eingabeWert) {
      if (eingabeWert.value != null && eingabeWert.value !== '') {
        let parsedValues = this.parseValues(eingabeWert);
        if (this.doPlausibilityCheck(parsedValues)) {
          this.triggerVorzugswertReminder(eingabeWert)
          this.commitSelectedEingabeWert(eingabeWert);
        } else {
          eingabeWert.value = '';
        }
      }
    },
    doPlausibilityCheck(parsedValues) {
      return (parsedValues.value <= parsedValues.upperBound
          && parsedValues.value >= parsedValues.lowerBound
          && this.isSchrittweite(parsedValues));
    },
    parseValues(eingabWert) {
      return {
        value: parseFloat(eingabWert.value),
        schrittweite: parseFloat(eingabWert.schrittweite),
        lowerBound: parseFloat(eingabWert.bereich.lowerBound),
        upperBound: parseFloat(eingabWert.bereich.upperBound),
      }
    },
    isSchrittweite(parsed) {
      let result = ((parsed.value - parsed.lowerBound) / parsed.schrittweite);
      let fixedResult = parseFloat(result.toFixed(5)); //Cut off any rounding error
      return Number.isInteger(fixedResult);
    },
    formInputState(eingabeWert) {
      if (eingabeWert.value != null && eingabeWert.value !== '') {
        let parsedValues = this.parseValues(eingabeWert);
        return this.doPlausibilityCheck(parsedValues);
      }
      return null;
    },
    commitSelectedEingabeWert(eingabeWert) {
      let attribut = this.attribut;
      let payload = {attribut: attribut, value: eingabeWert};
      this.$store.commit('setSelectedEingabeWert', payload);
    },
    getTooltipText(eingabeWert) {
      let text = this.$t('eingabe-werte.range') + ': '
          + eingabeWert.i18NName + '\r\n'
          + this.$t('eingabe-werte.increment') + ': '
          + eingabeWert.schrittweite + ' '
          + eingabeWert.einheit + '\r\n'
      return  text;
    },
    getLimitedText(eingabeWert) {
      let text = this.$t('eingabe-werte.limited')
      let wert = eingabeWert.name.replace('..', this.$t('eingabe-werte.to'))
      if (i18n.locale == 'de') {
        wert = wert.split(".").join(",");
        // wert = wert.replaceAll('.', ',')
      }
      return text + wert
    },
    triggerVorzugswertReminder(wert) {
      var array = this.attribut.auswahlWerte
      array = array.concat(this.attribut.eingabeWerte)
      for (let i = 0; i < array.length; i++) {
        if (array[i].vorzugswert && !wert.vorzugswert) {
          this.$store.commit('setNotificationContent', {variant: 'warning', title: this.$i18n.t('vorzugswert.alertTitle'), text: this.$i18n.t('vorzugswert.alertText'), dontHide: false});
          this.$store.commit('showNotification');
          return
        }
      }
    }
  }

}
</script>

<style scoped>
.top-buffer {
  margin-top: 7px
}

.padding-0 {
  padding-right: 0;
  padding-left: 1px;
}
</style>